export default __webpack_public_path__ + "static/shoulder-2fdb9852dfaef0133c15ab3e0ddb6ccd.jpg";